<template>
    <div class="page">
        <div class="header-box">
            <img src="../assets/images/logo.png" alt="">
            <div class="header-shop" v-show="isWechatStatus">
                <span>精酿商城</span>
                <toktokweapp class="header-shop-btn"></toktokweapp>
            </div>
        </div>
        <div class="video-box">
            <div v-show="!videoStatus"></div>
            <img @click="play()" v-show="!videoStatus" src="../assets/images/play.png" alt="">
            <video ref="player" loop :controls="videoStatus" poster="http://cdn.toktok.beer/toktok/video.png" src="http://cdn.toktok.beer/toktok/toktok_index.mp4" playsinline></video>
        </div>

        <div style="display:flex; flex-direction: column;background: #FFFFFF;">
            <div class="stores-title">关于TOKTOK</div>
            <div class="title-bottom"></div>
            <div class="story-text">
            TOKTOK是一家精酿啤酒厂牌，品牌理念是Everything is OK，致力于让人们品尝来自全国各地啤酒厂生产的新鲜啤酒。<br>
            美丽的色泽、浓郁的香气、细腻的口感，用精酿啤酒中的"故事"向您缓缓道来。<br>
            我们采用专利特色外带桶运输，保鲜黑科技，品质有保障。让每一位顾客在家中，就可以体验到啤酒厂新鲜出桶的原滋原味精酿鲜啤。
            </div>
            <img src="../assets/images/morehema.png" class="ok-img" alt="">
        </div>
        <div class="img-box">
            <img src="http://cdn.toktok.beer/toktok/img01.png" alt="">
            <span class="img-text1"></span>
            <span class="img-text2">探索享受啤酒的新方式。</span>
            <span class="img-text3">美丽的色泽、浓郁的香气、细腻的口感TOKTOK用精酿啤酒中的"故事"<br>向您缓缓道来。</span>
        </div>
        <div style="display:flex; flex-direction: column;">
            <div class="little_title">颜色Color</div>
            <div class="story-text">
                清爽的淡金色、自然的浅稻草色、怀旧的琥珀色、厚重的棕色、诱人的红色...<br>
                麦芽决定了精酿啤酒倒入玻璃杯中的色泽。<br>
                酿酒师用来自世界各地的优质麦芽搭配，创造出想象中的各种颜色。
            </div>
        </div>
        <div class="img-box">
            <img src="http://cdn.toktok.beer/toktok/img02.png" alt="">
        </div>
        <div style="display:flex; flex-direction: column;">
            <div class="little_title">香气Aroma</div>
            <div class="story-text">
                热带水果、蜂蜜、鲜花、麦香、烤面包 ...<br>
                入口之前，在鼻尖开启一场醇香之旅。<br>
                酿酒师以各种比例组合水果的酯香、麦芽的芳香、啤酒花香，让精酿啤酒散发多种香气。
            </div>
        </div>
        <div class="img-box">
            <img src="http://cdn.toktok.beer/toktok/img03.png" alt="">
        </div>
        <div style="display:flex; flex-direction: column;">
            <div class="little_title">风味Taste</div>
            <div class="story-text">
                浓郁的麦芽味、清爽的苦味、醇厚的甜味、新鲜的果味...<br>
                精酿啤酒拥有100多种世界公认的啤酒风格，在酿酒师的努力下，数量还在逐年增多。<br>
                相同风格的精酿啤酒，根据地区水质、酿造时间、酵母种类、季节作物的不同，尤其是酿酒师的技术和趣味性的差异，也会使味道千变万化。
            </div>
        </div>
        <div style="display:flex; flex-direction: column;background: #F5F5F5;">
            <div class="stores-title">TOKTOK门店信息</div>
            <div class="title-bottom"></div>
            <div class="stores-msg">
                TOKTOK已在广州开设10余家线下分店<br>
                我们提供24小时休闲服务，白天提供咖啡、面包、茶饮，晚上提供精酿啤酒供你享受，提倡“日清醒·夜微醺”的休闲生活理念，味觉享受与精致生活尽在TOKTOK。
            </div>

            <div>
                <div class="stores-box" v-for="(item, index) in storeList" :key="index">
                    <div class="stores-list">
                        <span>{{item.name}}</span>
                        <div v-show="item.tags!=''" :style="item.tags=='敬请期待'?'background: rgba(0, 0, 0, 0.28);':''">{{item.tags}}</div>
                    </div>
                    <div class="stores-at">
                        <div class="stores-at-item">
                            <img src="../assets/images/location.png" alt="">
                            <span>{{item.ad}}</span>
                        </div>
                        <div class="stores-at-item">
                            <img src="../assets/images/time.png" alt="">
                            <span>{{item.time}}</span>
                            <div v-show="item.opening && isWechatStatus" class="order-div">
                                <span>去点餐</span>
                                <weapp class="order-go" :path="item.path"></weapp>
                            </div>
                            <div v-show="!item.opening" class="order-msg">装修中敬请期待</div>
                        </div>
                    </div>
                </div>
            </div>

            <img src="../assets/images/hema.png" class="okk-img" alt="">
        </div>

        <div id="shop" style="background: #262211;">
            <img class="toktok-logo" src="../assets/images/logo.png" alt="">
            <div class="media-text">TOKTOK官方媒体：</div>
            <div class="media-img">
                <img src="../assets/images/gongzhonghao.png" alt="">
                <img src="../assets/images/shopcode.png" alt="">
            </div>
            <div class="media-name">
                <span>微信公众号</span>
                <span>精酿商城小程序</span>
            </div>
            <div class="tips-box">
                <span>TOKTOK温馨提示：</span>
                <span>1. 饮酒请适量，小饮怡情，大饮伤身。喝酒不宜开车，请勿酒后驾驶。</span>
                <span>2. 未成年人不得饮酒，孕妇和儿童不宜饮酒。</span>
            </div>
            <div class="beian-ph" @click="beianClick()">
                <div class="toktok-ph-beian">
                    版权所有 ©{{tYear}} 广州行深科技有限公司
                </div>
                <div class="toktok-ph-beian">
                    粤ICP备17037030号
                </div>
                <div class="toktok-ph-beian">
                    信息产业部备案管理系统.
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import net from '../action/net';
import weapp from '../components/weapp.vue'
import toktokweapp from '../components/toktokweapp.vue'

export default {
    name:'index',
    components: {
        weapp,
        toktokweapp
    },
    data(){
        return{
            creenWidth: document.body.clientWidth,
            videoStatus: false,
            storeList: [
                {
                    name: '市二宫店',
                    tags: '新店',
                    ad: '广州市海珠区江南大道中89号之四6998LUCK B114铺（负一层）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?newAdvance=false&reserveMode=0&payOpenId=&entrance=80&tenantId=10215149&restaurantViewId=&paySource=0&minaId=&spuId=&orderBizTag=0&shopId=601426200&tableNum=29866410&brandId=&authGeo=undefined'
                },
                {
                    name: '龙洞店',
                    tags: '新店',
                    ad: '广州市天河区迎龙路1号1160室',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=600326998&restaurantViewId=172288&cacheKey=1405742492195807307_600326998_5.54.05&wxAppVersion=5.54.05&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
                {
                    name: '花地湾店',
                    tags: '新店',
                    ad: '广东省广州市荔湾区东漖北路与浣花路交汇东北',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=600450711&restaurantViewId=172288&cacheKey=1405742492195807307_600450711_5.54.05&wxAppVersion=5.54.05&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
                {
                    name: '星寰广场店',
                    tags: '',
                    ad: '越秀区侨光西路11号星寰国际商业广场负一楼（南门旋转楼梯附近）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=601086122&restaurantViewId=172288&cacheKey=1405742492195807307_601086122_5.43.02&wxAppVersion=5.43.02&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
                {
                    name: '设计之都店',
                    tags: '',
                    ad: '广州市白云区鹤龙街道白云区黄边北路150号设计之都时光汇1030铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-main/pages/main/index.html?multiShop=1&scanId=1673084916430-56557-9712&reserveMode=0&t=1673084916416&shopId=600795330&uuid=null&payMode=1&entrance=43&fromShopList=1&sign=ef3154265655d2c865371acfe2271f77&tenantId=10215149&qrcodeType=null&paySource=152&newAdvance=true&bizType=1&funcMode=1&autoTakeOrder=1&payOpenId=&accountMode=2&tableNum=&bizMode=1&dishSource=0&orderBizTag=1&scene=0'
                },
                {
                    name: '合生广场店',
                    tags: '',
                    ad: '广州市海珠区叠景路168号170号合生广场101房之九铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?scanId=1661332908472-7456-271&reserveMode=0&t=1661332908457&shopId=600643920&uuid=1rPdk9z3Ccm&payMode=2&entrance=80&sign=cf76d299b0a24bb9d030a6283ba77033&tenantId=10215149&qrcodeType=1&funcMode=1&bizType=0&autoTakeOrder=1&accountMode=2&payOpenId=&tableNum=18216011&dishSource=0&bizMode=1&perceptionPage=true&orderBizTag=0&scene=0'
                },
                {
                    name: '天河新天地店',
                    tags: '',
                    ad: '广州市天河区天源路5号天河新天地首层L137号商铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?newAdvance=false&reserveMode=0&payOpenId=null&entrance=80&tenantId=10215149&restaurantViewId=&paySource=0&minaId=&spuId=&orderBizTag=0&shopId=600348263&tableNum=16226229'
                },
                {
                    name: '天河北店',
                    tags: '',
                    ad: '广州市天河区天河北路628号保利中宇广场首层301铺之二',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?scanId=1652758167418-1379-48137&reserveMode=0&t=1652758167398&shopId=600561713&uuid=1okujH21msd&payMode=2&entrance=80&sign=21238d9ffc4af689ac62322171fa521a&tenantId=10215149&qrcodeType=1&funcMode=1&bizType=0&autoTakeOrder=0&accountMode=1&payOpenId=null&tableNum=16226310&dishSource=0&bizMode=1&perceptionPage=true&orderBizTag=0&scene=0'
                },
                {
                    name: '黄埔古港店',
                    tags: '',
                    ad: '广州市海珠区石基路512号古港新地C1079-1080（黄埔古港景观区旁）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?newAdvance=false&reserveMode=0&payOpenId=null&entrance=80&tenantId=10215149&restaurantViewId=&paySource=0&minaId=&spuId=&orderBizTag=0&shopId=600515518&tableNum=15122827'
                },
                {
                    name: '广州荔枝湾店',
                    tags: '',
                    ad: '广州市荔湾区龙津西路94号古玩城D103铺（荔枝湾景区旁）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?payOpenId=null&minaId=&newAdvance=false&orderBizTag=0&reserveMode=0&restaurantViewId=&tenantId=10215149&tableNum=14489292&paySource=null&spuId=&shopId=600509146&entrance=40'
                },
                {
                    name: '米酷店（万科云城)',
                    tags: '',
                    ad: '广州市天河区万科云城米酷B4栋107、108铺（近天河智慧城地铁B出口）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?newAdvance=false&reserveMode=0&payOpenId=null&entrance=80&tenantId=10215149&restaurantViewId=&paySource=null&minaId=&spuId=&orderBizTag=0&shopId=600343939&tableNum=10732595',
                },
                {
                    name: '黄埔南村店',
                    tags: '',
                    ad: '广州市百合三街 6 号 101 铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=600576175&restaurantViewId=172288&cacheKey=1405742492195807307_600576175_5.54.05&wxAppVersion=5.54.05&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
            ],
            tYear: null,
            isWechatStatus: false
        }
    },
    computed:{
        store_open: function() {
            let n = 0;
            this.storeList.filter(item=>{
                if(item.opening){
                    n++
                }
            })
            return n
        },
        store_ready: function() {
            let n = 0;
            this.storeList.filter(item=>{
                if(!item.opening){
                    n++
                }
            })
            return n
        },
    },
    created:function(){
        var myDate = new Date();
        this.tYear = myDate.getFullYear();
        net.getShopWxConfig();
        this.isWechat();
    },
    mounted:function(){
        let that = this;
        that.$refs.player.addEventListener('play',function(){
            that.videoStatus = true;
        });
        that.$refs.player.addEventListener('pause',function(){
            that.videoStatus = false;
        });
    },
    methods:{
        // tokShop() {
        //     document.getElementById("shop").scrollIntoView();
        // },
        play() {
            this.$refs.player.play();
        },
        beianClick() {
            window.open('https://beian.miit.gov.cn');
        },
        isWechat() {
            if(navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
                this.isWechatStatus = true;
            }else{
                this.isWechatStatus = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// @import 'src/styles/index.css';
@font-face{
    font-family: mySourceHan;
    src: url('../assets/font/SourceHanSerifCN-subset.ttf');
}
.page{
    width: 100%;
    min-width: 320px;
    height: auto;
}
.media-text{
    width: calc(100% / 1.72);
    height: 18px;
    margin: 0 auto 12px;
    line-height: 18px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: left;
}
.media-name{
    width: calc(100% / 1.72);
    height: 18px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 12px auto 0;
}
.media-name>span{
    width: calc(100% / 2.38);
    max-width: 104px;
    min-width: 77px;
    height: 18px;
    line-height: 18px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: center;
    white-space:nowrap
}
.media-img{
    width: calc(100% / 1.72);
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
}
.media-img>img{
    width: calc(100% / 2.38);
    height: calc(100% / 2.38);
    // max-width: 104px;
    min-width: 77px;
    // max-height: 104px;
    min-height: 77px;
}
.toktok-logo{
    width: calc(100% / 2.2);
    max-width: 198px;
    min-width: 146px;
    max-height: 123px;
    min-height: 92px;
    margin: 56px auto;
}
.header-box{
    width: calc(100% - 32px);
    height: 64px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #262211;
}
.header-box>img:nth-child(1){
    width: 72px;
    height: 45px;
    margin: auto 0;
}
.header-shop{
    width: 80px;
    height: 24px;
    line-height: 24px;
    margin: auto 0;
    position: relative;
}
.header-shop>span:nth-child(1){
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
    width: auto;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin: auto 0;
}
.header-shop-btn{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 24px;
    z-index: 999;
    opacity: 0;
}
.video-box{
    width: 100%;
    height: 321px;
    position: relative;
}
.video-box>div:first-child{
    width: 100%;
    height: 321px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: #00000041;
    -webkit-filter: brightness(76%);
    filter: brightness(76%);
}
.video-box>img{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    width: 56px;
    height: 56px;
    // -webkit-filter: brightness(76%);
    // filter: brightness(76%);
}
.video-box>video{
    outline: 0;
    width: 100%;
    height: 321px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    object-fit: cover;
    // -webkit-filter: brightness(76%);
    // filter: brightness(76%);
}
.img-box{
    width: 100%;
    height: 456px;
    position: relative;
    display: flex;
    flex-direction: column;
}
.img-box>img:first-child{
    width: 100%;
    height: 456px;
    object-fit: cover;
    -webkit-filter: brightness(84%);
    filter: brightness(84%);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.img-text1{
    width: 32px;
    height: 7px;
    margin: 64px auto 12px 40px;
    z-index: 2;
    background: #FFFFFF;
}
.img-text2{
    max-width: 280px;
    height: auto;
    line-height: 53px;
    margin: 0 40px 40px;
    z-index: 2;
    font-size: 38px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    letter-spacing: 2px;
    text-align: left;
}
.img-text3{
    max-width: 280px;
    height: auto;
    line-height: 34px;
    margin: 0 40px;
    z-index: 2;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: left;
}
.story-text{
    width: auto;
    height: auto;
    line-height: 34px;
    margin: 0 40px 56px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    text-align: left;
}
.ok-img{
    width: calc(100% - 80px);
    height: auto;
    margin: 0 40px 56px;
}
.little_title{
    width: auto;
    height: 42px;
    line-height: 42px;
    margin: 56px auto 47px 40px;
    padding-bottom: 12px;
    text-align: left;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    border-bottom: 2px solid rgba(0, 0, 0, 0.87);
    letter-spacing: 2px;
}
.stores-box{
    width: auto;
    height: auto;
    margin: 0 40px 16px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 5px 21px 0px rgba(102,102,102,0.06);
    border-radius: 4px;
}
.stores-at{
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
}
.stores-at>div:nth-child(1){
    margin-bottom: 8px;
}
.stores-at-item{
    display: flex;
    flex-direction: row;
}
.stores-at-item>img:nth-child(1){
    width: 14px;
    height: 14px;
    margin: 3px 8px auto 0;
}
.stores-at-item>span:nth-child(2){
    max-width: 80%;
    width: auto;
    height: auto;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.4);
    line-height: 18px;
    text-align: left;
}
.order-div{
    width: 54px;
    height: 20px;
    position: relative;
    margin-left: auto;
    // transform: scale(0.8);
    // -webkit-transform: scale(0.8);
}
.order-div>span:nth-child(1){
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 8;
    width: 53px;
    height: 17px;
    line-height: 15px;
    text-align: center;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 600;
    color: #FD4F00;
    border: 1px solid #FD4F00;
    padding-top: 4px;
    cursor: pointer;
}
.order-go{
    position: absolute;
    left: 0;
    top: 0;
    width: 53px;
    height: 17px;
    border-radius: 12px;
    z-index: 999;
    opacity: 0;
}
.order-msg{
    width: auto;
    height: 16px;
    margin-left: auto;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FD4F00;
    line-height: 16px;
}
.stores-list{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 21px;
    margin-bottom: 12px;
}
.stores-list>span:nth-child(1){
    width: auto;
    height: 21px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    line-height: 21px;
    text-align: left;
    margin: auto 0;
}
.stores-list>div:nth-child(2){
    width: auto;
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFF;
    line-height: 14px;
    text-align: center;
    background: #FD4F00;
    border-radius: 14px;
    margin: auto 0;
    padding: 2px 10px;
    transform: scale(0.80);
    -webkit-transform: scale(0.80);
}
.stores-title{
    width: auto;
    height: auto;
    line-height: 46px;
    padding: 56px 40px 0;
    font-size: 32px;
    font-family: mySourceHan;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 1px;
    text-align: left;
}
.title-bottom{
    margin: 8px auto 32px 40px;
    width: 32px;
    height: 5px;
    background: #FD4F00;
}
.stores-msg{
    width: auto;
    height: auto;
    margin: 0 40px 32px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    line-height: 34px;
    text-align: left;
}
.okk-img{
    max-width: 274px;
    max-height: 240px;
    width: calc(100% / 1.56);
    height: calc(100% / 1.56);
    margin: 46px auto 64px;
}
.beian-ph{
    width: auto;
    margin: 0 40px;
    height: 176px;
    background: #262211;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #979797;
}
.beian-ph>div:first-child{
    margin-top: 31px;
}
.toktok-ph-beian{
    height: 27px;
    width: 100%;
    line-height: 27px;
    font-weight: 400;
    color: #999999;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
}
.tips-box{
    width: auto;
    height: auto;
    padding: 56px 40px 48px;
    display: flex;
    flex-direction: column;
}
.tips-box>span{
    text-align: left;
    width: auto;
    height: auto;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
    line-height: 27px;
}
@media screen and (max-width: 340px) {
    .stores-box{
        padding: 12px;
    }
    .order-div{
        transform: scale(0.8);
        -webkit-transform: scale(0.8);
    }
    .order-msg{
        transform: scale(0.8);
        -webkit-transform: scale(0.8);
    }
}
@media screen and (max-width: 427px) {
    .stores-title{
        font-size: 24px;
    }
    .story-text{
        font-size: 12px;
        line-height: 30px;
    }
    .img-text2{
        font-size: 32px;
        line-height: 47px;
    }
    .img-text3{
        line-height: 32px;
        font-size: 14px;
    }
    .little_title{
        font-size: 24px;
        height: 36px;
        line-height: 36px;
    }
    .stores-msg{
        font-size: 12px;
        line-height: 30px;
    }
}
@media screen and (min-width: 428px) {
    // .stores-box{
    //     padding: 36px;
    // }
    .stores-list>span:nth-child(1){
        font-size: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_index.vue